import ProgressIndicator from '@/components/progressIndicator';
import { useApiContext } from '@/contexts/apiContext';
import { useNotificationContext } from '@/contexts/notificationContext';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import UserAppShell from './userAppShell';

const UserAppInstance = () => {
  const apiContext = useApiContext();
  const { toast } = useNotificationContext();

  const { appDefId, appInstanceId } = useParams();

  const [loading, setLoading] = useState(false);
  const [userAppInstance, setUserAppInstance] = useState<any>();
  const [error, setError] = useState<any>();

  useEffect(() => {
    const getUserApp = async () => {
      try {
        setLoading(true);
        const response = await apiContext.getUserAppInstance(appDefId as string, appInstanceId as string);
        setUserAppInstance(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    if (appDefId && appInstanceId) {
      getUserApp();
    }
  }, [appDefId, appInstanceId]);

  const reloadApp = async () => {
    try {
      const response = await apiContext.getUserAppInstance(appDefId as string, appInstanceId as string);
      setUserAppInstance(response);
    } catch (error) {
      setError(error);
    }
  };

  const updateApp = async (updatedApp: any) => {
    try {
      const { id, tenantId, name, description, entityType, entityDefId, settings, eventSubscriptions, sourceEntities } =
        updatedApp;

      await apiContext.updateUserAppInstance(appDefId as string, appInstanceId as string, {
        id,
        tenantId,
        name,
        description,
        entityType,
        entityDefId,
        settings,
        eventSubscriptions,
        sourceEntities,
      });
      setUserAppInstance({ ...updatedApp, userAccess: userAppInstance.userAccess });
      toast({ message: 'Changes saved' });
    } catch (error) {
      setError(error);
    }
  };

  if (loading) {
    return <ProgressIndicator />;
  }

  return (
    <UserAppShell
      userAppInstance={userAppInstance}
      updateUserAppInstance={updateApp}
      reloadUserAppInstance={reloadApp}
      error={error}
    />
  );
};

export default UserAppInstance;
